<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="d-flex flex-row title-line">
  <well-page-title
    title="{{isAdministrator ? ('company.subscription-type.actions-list.list.adminTitle' | translate) : ('company.subscription-type.actions-list.list.title' | translate)}}">
  </well-page-title>

  <div class="button-mt mr-md" style="display: flex">
    <button pButton type="button" class="p-button-outlined"
            [label]="'company.subscription-type.add' | translate"
            icon="ui-icon-add" (click)="addNew()" data-testid="add-new-btn">
    </button>
  </div>
</div>

<p-dialog header="{{'company.subscription-type.actions-list.addTitle' | translate}}"
          [(visible)]="newInputs"
          [responsive]="true"
          [style]="{width: '450px'}"
          [modal]="true"
          [draggable]="false"
          [closable]="true">
  <well-action-add-page *ngIf="newInputs" (saveSuccess)="hideNewInputs()"
                        (cancelOperation)="hideNewInputs()"
                        [subscriptionTypeUuid]="subscriptionTypeUuid">
  </well-action-add-page>
</p-dialog>

<p-dialog header="{{'company.subscription-type.actions-list.addTitle' | translate}}"
          [(visible)]="editInputs"
          [responsive]="true"
          [modal]="true"
          [draggable]="false"
          [closable]="true">
  <well-action-edit-page *ngIf="editInputs"
                         (saveSuccess)="hideEditInputs()"
                         (cancelOperation)="hideEditInputs()"
                         [uuid]="selectedActionUuid"
                         [subscriptionTypeUuid]="subscriptionTypeUuid">
  </well-action-edit-page>
</p-dialog>

<well-action-list
  [list]="actions"
  [totalSize]="totalSize"
  [actionNameList]="actionNameList"
  [isAdministrator]=isAdministrator
  (lazyLoad)="lazyLoadActions($event)"
  (rowAction)="rowAction($event)">
</well-action-list>


